import type { HelpPortalSource } from "@/lib/help-portal";
import {
  HELP_ARTICLES,
  HELP_CATEGORIES,
  articlesInCategory,
} from "@/lib/registrant-help/articles";
import { searchHelpArticles } from "@/lib/registrant-help/search";

export const REGISTRANT_HELP_PORTAL: HelpPortalSource = {
  articles: HELP_ARTICLES,
  categories: HELP_CATEGORIES,
  searchArticles: searchHelpArticles,
  articlesInCategory,
  indexTo: "/registrant/help",
  articleTo: "/registrant/help/$articleId",
  emptySearchHint:
    "Try a different word, such as account, invite, pay, transfer, renew, invoice, or users.",
};
